import { BizzComponent } from './app/bizz.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { APP_CONFIG } from './app/app.config';

bootstrapApplication(BizzComponent, APP_CONFIG)
  .catch(err => console.error(err));
